import { generatedTypesNew } from '@css-xp/graphtypes';

export const getPaymentMethodText = (
  paymentMethod: generatedTypesNew.InvoicePaymentMethod | null | undefined,
  creditCard: generatedTypesNew.CreditCardDetails | undefined | null,
  invoiceDueDays: number | null | undefined,
  hasPayByStatement?: boolean
): string | undefined => {
  if (paymentMethod) {
    if (
      paymentMethod === generatedTypesNew.InvoicePaymentMethod.PAIDCC ||
      paymentMethod === generatedTypesNew.InvoicePaymentMethod.STRIPE_CARD
    ) {
      return creditCard?.last4Numbers ? `**** **** **** ${creditCard.last4Numbers}` : '';
    }
    if (paymentMethod === generatedTypesNew.InvoicePaymentMethod.PAIDONACCOUNT || hasPayByStatement) {
      return 'Pay on account';
    }
    if (paymentMethod === generatedTypesNew.InvoicePaymentMethod.DEFERRED) {
      return invoiceDueDays ? `Payment terms (Net ${invoiceDueDays})` : 'Payment terms';
    }
    if (isPaypalPaymentMethod(paymentMethod)) {
      return 'Paypal';
    }
  }
};

export const isPaypalPaymentMethod = (paymentMethod: any) => {
  return paymentMethod === 'PAYPAL' || paymentMethod === 'PAIDPAYPAL';
};

export const isAchPaymentMethod = (paymentMethod: any) => {
  return paymentMethod === generatedTypesNew.PaymentMethodTypeV2.ACH;
};

export const shouldShowACHPaymentMethod = (selectedPartnerCountry?: string, isACHPaymentMethodFFEnabled?: boolean) => {
  return isACHPaymentMethodFFEnabled && selectedPartnerCountry === 'US';
};
